export * from './src/common';
export * from './src/forum';
import { extend } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';

app.initializers.add('ljstudio-signup', () => {
  console.log('[ljstudio/signup] Customizing fields and order with label for Dátum narodenia');

  extend(SignUpModal.prototype, 'oninit', function () {
    this.krstneMeno = Stream('');        // Initialize first name field
    this.priezvisko = Stream('');        // Initialize last name field
    this.datumNarodenia = Stream('');    // Initialize date of birth field
  });

  extend(SignUpModal.prototype, 'data', function (data) {
    // Add custom fields to the form data payload
    data['krstne_meno'] = this.krstneMeno();
    data['priezvisko'] = this.priezvisko();
    data['datum_narodenia'] = this.datumNarodenia();
  });


  extend(SignUpModal.prototype, 'onsubmit', function() {
    console.log(this, {
      nickname: this.username(),
      krstne_meno: this.krstneMeno(),
      priezvisko: this.priezvisko(),
      datum_narodenia: this.datumNarodenia(),
    });

  });


  // Extend the fields method of SignUpModal to modify form fields
  extend(SignUpModal.prototype, 'fields', function(fields) {
    console.log('Modifying SignUpModal fields order with label for Dátum narodenia:', fields);

    // Remove all fields (so we can re-add them in the desired order)
    fields.remove('username');  // Remove username field (we'll re-add it later as nickname)
    fields.remove('email');     // Remove email field
    fields.remove('password');  // Remove password field

    // Add fields in the desired order with correct attributes

    // 1. Prezývka (Nickname)
    fields.add('nickname',
      m('div.Form-group', [
        m('input.FormControl', {
          name: 'nickname',
          type: 'text',
          placeholder: 'Prezývka',
          bidi: this.username  // Nickname is still tied to the "username" in Flarum
        })
      ])
    );

    // 2. Krstné meno (First Name)
    fields.add('krstneMeno',
      m('div.Form-group', [
        m('input.FormControl', {
          name: 'krstne_meno',
          type: 'text',
          placeholder: 'Krstné meno',
          bidi: this.krstneMeno
        })
      ])
    );

    // 3. Priezvisko (Last Name)
    fields.add('priezvisko',
      m('div.Form-group', [
        m('input.FormControl', {
          name: 'priezvisko',
          type: 'text',
          placeholder: 'Priezvisko',
          bidi: this.priezvisko
        })
      ])
    );

    // 4. Dátum narodenia (Date of Birth) with a label
    fields.add('datumNarodenia',
      m('div.Form-group', [
        m('label', { for: 'datum_narodenia' }, 'Dátum narodenia'), // Label for date of birth
        m('input.FormControl', {
          id: 'datum_narodenia',
          name: 'datum_narodenia',
          type: 'date',
          bidi: this.datumNarodenia
        })
      ])
    );

    // 5. Email
    fields.add('email',
      m('div.Form-group', [
        m('input.FormControl', {
          name: 'email',
          type: 'email',
          placeholder: 'Email',
          bidi: this.email
        })
      ])
    );

    // 6. Heslo (Password)
    fields.add('password',
      m('div.Form-group', [
        m('input.FormControl', {
          name: 'password',
          type: 'password',
          placeholder: 'Heslo',
          bidi: this.password
        })
      ])
    );
  });

  // // Redefine submitData to include custom fields in the payload
  // SignUpModal.prototype.submitData = function () {
  //   // Get default fields
  //   const data = {
  //     nickname: this.username(),
  //     username: this.username(),
  //     email: this.email(),
  //     password: this.password(),
  //   };

  //   // Add custom fields to the data object
  //   data['krstne_meno'] = this.krstneMeno();
  //   data['priezvisko'] = this.priezvisko();
  //   data['datum_narodenia'] = this.datumNarodenia();

  //   console.log('Final Payload Data:', data); // Log the final payload data to verify
  //   return data;
  // };

    // Override submitData to include custom fields without removing g-recaptcha-response
    const originalSubmitData = SignUpModal.prototype.submitData;
    SignUpModal.prototype.submitData = function () {
      // Get the original data from the default submitData
      const data = originalSubmitData.call(this);

      // Add custom fields to the data object
      data['krstne_meno'] = this.krstneMeno();
      data['priezvisko'] = this.priezvisko();
      data['datum_narodenia'] = this.datumNarodenia();
      data['nickname'] = this.username();

      console.log('Final Payload Data:', data); // Log the final payload data to verify
      return data;
    };

});
